export default "__VITE_ASSET__DOkHuXj$__"